import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/home";
import Competitions from "./pages/competitions";
import CompetitionsDetail from "./pages/competitions_detail";
import Highlights from "./pages/highlights";
import Contact from "./pages/contact";
import About from "./pages/about";
import SuccessPage from "./pages/200";
import NotFound from "./pages/404";
import ServerError from "./pages/500";
import AdminDashboard from "./pages/admin/dashboard";
import SupportChatWidget from "./components/whatsapp";

function App() {
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      <div className="min-h-screen bg-background w-full">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/competitions" element={<Competitions />} />
          <Route path="/competitions/:id*" element={<CompetitionsDetail />} />
          <Route path="/highlights" element={<Highlights />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/200" element={<SuccessPage />} />
          <Route path="/500" element={<ServerError />} />

          {/* 404 Fallback */}
          <Route
            path="*"
            element={
              isAdminRoute ? (
                <div className="min-h-screen relative overflow-hidden bg-gradient-to-br from-black via-zinc-900 to-black flex items-center justify-center px-6">

                  {/* Background Glow */}
                  <div className="absolute w-[400px] h-[400px] bg-QWA2_TALENT_SHOW-red/20 blur-3xl rounded-full top-[-120px] left-[-120px]" />
                  <div className="absolute w-[350px] h-[350px] bg-QWA2_TALENT_SHOW-gold/20 blur-3xl rounded-full bottom-[-120px] right-[-120px]" />

                  {/* Card */}
                  <div className="relative z-10 w-full max-w-lg bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl shadow-2xl p-10 text-center">

                    {/* Badge */}
                    <div className="inline-flex items-center justify-center px-5 py-2 rounded-full bg-QWA2_TALENT_SHOW-gold/10 border border-QWA2_TALENT_SHOW-gold/20 mb-6">
                      <span className="text-QWA2_TALENT_SHOW-gold font-black uppercase tracking-[0.25em] text-sm">
                        Admin Area
                      </span>
                    </div>

                    {/* Title */}
                    <h1 className="text-5xl font-black text-white leading-tight">
                      Page Not Found
                    </h1>

                    {/* Description */}
                    <p className="mt-5 text-gray-300 leading-relaxed text-lg">
                      The admin page you are looking for does not exist,
                      was moved, or you do not have permission to access it.
                    </p>

                    {/* Button */}
                    <a
                      href="/admin/"
                      className="mt-10 inline-flex items-center justify-center rounded-2xl bg-gradient-to-r from-QWA2_TALENT_SHOW-red to-QWA2_TALENT_SHOW-gold px-8 py-4 text-white font-bold uppercase tracking-wider shadow-lg hover:scale-105 hover:opacity-95 transition-all duration-300"
                    >
                      Back to Admin
                    </a>

                    {/* Small Text */}
                    <p className="mt-6 text-sm text-gray-500">
                      QWAQWA Talent Show Administration
                    </p>
                  </div>
                </div>
              ) : (
                <NotFound />
              )
            }
          />
        </Routes>
        <Toaster />
      </div>
      <SupportChatWidget />
    </>
  );
}

export default App;
